import { clsx } from 'clsx'
import { memo } from 'react'
import { Container } from 'react-bootstrap'

import styles from './styles.module.scss'

const FCBody = ({ children, hideOverlow }) => (
  <Container style={{ flex: 1 }}>
    <main
      id="main"
      className={clsx(styles.main, {
        [styles['main_hide-overflow']]: hideOverlow,
      })}
    >
      {children}
    </main>
  </Container>
)

export const Body = memo(FCBody)
